import { useEffect, useState } from 'react';
import { getProgramDataAPI } from './utils';

export function useProgram({ programID }) {
  const [program, setProgram] = useState([]);
  const [programLoaded, setProgramLoaded] = useState(false);
  const [programCourses, setProgramCourses] = useState([]);
  const [programCoursesLoaded, setProgramCoursesLoaded] = useState(false);

  useEffect(() => {
    getProgramDataAPI(programID, getProgramDataCallback, getProgramCoursesCallback);
    //getProgramCoursesAPI(programID, getProgramCoursesCallback);
  }, []);

  const getProgramDataCallback = (data) => {
    setProgram(data);
    setProgramLoaded(true);

  };

  const getProgramCoursesCallback = (data) => {
    setProgramCourses(data);
    // setProgramCourses(data);
    setProgramCoursesLoaded(true);
  };

  return [
    program as any,
    programLoaded,
    programCourses as any[],
    programCoursesLoaded,
  ];
}
